/* eslint-disable arrow-body-style */
import axios from 'axios';

import common from '~/common';
import { logError } from '~/common/utils';
import excel from '~/skills/excel';
const developIp = `${common.Ip.Actions}/v2`;
const getHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const wind_id = () => localStorage.getItem('Wind_ID');
///
const clearKey = (dispatch, { key = '' }) => dispatch({ type: 'clear', label: key });
const setLoading = value => ({ type: 'loading_add', value });
const removeLoading = value => ({ type: 'loading_del', value });

const getAllDocks = dispatch => {
    const key = 'AllDocks';
    dispatch(setLoading(key));
    axios.get(`${developIp}/docksys/view/ducks/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getAllDocks');
            dispatch(removeLoading(key));
        });
};

const getAllNearLands = dispatch => {
    const key = 'AllNearLands';
    dispatch(setLoading(key));
    axios.get(`${developIp}/docksys/view/near_lands/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getAllNearLands');
            dispatch(removeLoading(key));
        });
};

const getAllWindContracts = dispatch => {
    const key = 'AllWindContracts';
    dispatch(setLoading(key));
    axios.get(`${developIp}/docksys/view/windcontract_names/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getAllWindContracts');
            dispatch(removeLoading(key));
        });
};

const getAllStoreParts = dispatch => {
    const key = 'AllStoreParts';
    dispatch(setLoading(key));
    axios.get(`${developIp}/docksys/view/store_parts/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getAllStoreParts');
            dispatch(removeLoading(key));
        });
};

const getStorePartDockInfo = (view_id, body) => {
    return axios.post(`${developIp}/docksys/view/${view_id}/new/v2/`, body, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                const list = res.data.data.data_rows || [];
                return list;
            }
        })
        .catch(error => {
            logError(error, 'getStorePartDockInfo');
            return [];
        });
};

const getWindTurbineNum = (dispatch, wind_id) => {
    const key = 'WindTurbineNum';
    dispatch(setLoading(key));
    axios.get(`${developIp}/dailyplan/data_converter/windcontract/${wind_id}/wind_turbine_num/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data.wind_turbine_num, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getWindTurbineNum');
            dispatch(removeLoading(key));
        });
};

const getDailyPlanStats = (body) => {

    return axios.post(`${developIp}/frontend/dailyplan/report/stats_info/new/v2/`, body, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                const result = res.data.data || {};
                return result;
            }
        })
        .catch(error => {
            logError(error, 'getDailyPlanStats');
            return [];
        });
};

const getWorkingPhase = (body) => {
    return axios.post(`${developIp}/dailyplan/working_phases/new/v2/`, body, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                const list = res.data.data || [];
                return list;
            }
        })
        .catch(error => {
            logError(error, 'getWorkingPhase');
            return [];
        });
};

const getSingleWindExcel = ({ plan_id, type, query_date }) => {
    return axios.get(`${developIp}/dailyplan/${plan_id}/type/${type}/query_date/${query_date}/excel/path/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                const fileurl = res.data.data.file_url || '';
                return fileurl;
            }
        })
        .catch(error => {
            logError(error, 'getSingleWindExcel');
            return '';
        });
};

const getMultipleWindExcel = (body) => {
    return axios.post(`${developIp}/dailyplan/windcontracts/type/query_date/excel/path/new/v2/`, body, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                const fileurl = res.data.data.file_url || '';
                return fileurl;
            }
        })
        .catch(error => {
            logError(error, 'getMultipleWindExcel');
            return '';
        });
};

const getGisStepReportDataV2 = (dispatch, { start_date, end_date }) => {
    const key = 'GisStepReportDataV2';
    clearKey(dispatch, { key });
    dispatch(setLoading(key));
    axios.get(`${developIp}/frontend/projectplan/start_date/${start_date}/end_date/${end_date}/this_week_progress/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data.data, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getGisStepReportDataV2');
            dispatch(removeLoading(key));
        });
};

const getGisStepReportDataV2R2 = (dispatch, { time_unit, start_date, end_date }) => {
    const key = 'GisStepReportDataV2R2';
    clearKey(dispatch, { key });
    dispatch(setLoading(key));
    axios.get(`${developIp}/frontend/projectplan/time_unit/${time_unit}/start_date/${start_date}/end_date/${end_date}/this_week_progress/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data.data, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getGisStepReportDataV2R2');
            dispatch(removeLoading(key));
        });
};

const getWindcontractsV2 = dispatch => {
    const key = 'WindcontractsV2';
    clearKey(dispatch, { key });
    dispatch(setLoading(key));
    axios.get(`${developIp}/frontend/windcontracts/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data.data, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getWindcontractsV2');
            dispatch(removeLoading(key));
        });
};

const getAdministrativeContractFieldNames = dispatch => {
    const key = 'AdministrativeContractFieldNames';
    clearKey(dispatch, { key });
    dispatch(setLoading(key));
    axios.get(`${developIp}/frontend/windcontracts/projectplan/administrative_contract/field_names/new/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                dispatch({ type: 'post', body: res.data.data.data, label: key });
            }
        })
        .catch(error => {
            logError(error, 'getAdministrativeContractFieldNames');
            dispatch(removeLoading(key));
        });
};

const getAdministrativeContracts = (body) => {
    return axios.post(`${developIp}/contract/windcontracts/projectplans/administrative_contracts/fields/details/new/v2/`, body, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                const result = res.data.data || [];
                return result;
            }
        })
        .catch(error => {
            logError(error, 'getAllUnapprovalAdminPrograms');
            return [];
        });
};

const getAllUnapprovalAdminPrograms = async () => {
    return axios.get(`${developIp}/approval_remind/administrative_progress/reports/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                const result = res.data.data || [];
                return result;
            }
        })
        .catch(error => {
            logError(error, 'getAllUnapprovalAdminPrograms');
            return [];
        });
};

const getAllUnapprovalWorkProgress = async () => {
    return axios.get(`${developIp}/approval_remind/work_progress/reports/v2/`, getHeaders())
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200') {
                const result = res.data.data || [];
                return result;
            }
        })
        .catch(error => {
            logError(error, 'getAllUnapprovalWorkProgress');
            return [];
        });
};

const getProgressTrackingSheetDocuments = (body) => {
    return axios.post(
        `${developIp}/windcontract/progress_tracking_sheet/documents/`,
        body,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            }
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                const result = res.data || {};
                return result;
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "getProgressTrackingSheetDocuments");
            return [];
        });
};

const getManagerProgressTrackingSheetDocuments = (body) => {
    return axios.post(
        `${developIp}/windcontract/progress_tracking_sheet/manager_type/documents/`,
        body,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            }
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                const result = res.data || {};
                return result;
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "getManagerProgressTrackingSheetDocuments");
            return [];
        });
};


const getProgressTrackingSheetColumnInfo = async () => {
    return axios.get(
        `${developIp}/windcontract/progress_tracking_sheet/document/column_info/`,
        getHeaders()
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                const result = res.data.data || [];
                return result;
            } else {
                return [];
            }
        })
        .catch((error) => {
            logError(error, "getProgressTrackingSheetColumnInfo");
            return [];
        });
};

const createProgressTrackingSheetDocument = async (formData) => {
    return axios.post(
        `${developIp}/windcontract/progress_tracking_sheet/new_document/`,
        formData,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            },
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                return res.data.data || {};
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "createProgressTrackingSheetDocument");
            return {};
        });
};

const getLastProgressTrackingSheetDocument = async (body) => {
    try {
        return axios.post(
            `${developIp}/windcontract/progress_tracking_sheet/document/last_document/`,
            body,
            {
                headers: {
                    "Content-Type": "application/json",
                    ...getHeaders().headers,
                },
            }
        ).then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                return res.data.data || {};
            } else {
                return {};
            }
        })
            .catch((error) => {
                logError(error, "getLastProgressTrackingSheetDocument");
                return {};
            });
    } catch (error) {
        logError(error, 'getLastProgressTrackingSheetDocument');
        return null;
    }
};

const getAProgressTrackingSheetDocument = async (sheet_id) => {
    try {
        const res = await axios.get(
            `${developIp}/windcontract/progress_tracking_sheet/${sheet_id}/document/`,
            getHeaders()
        );

        if (res.data.status === 200 || res.data.status === "200") {
            return res.data.data?.data || [];
        } else {
            return [];
        }
    } catch (error) {
        logError(error, "getAProgressTrackingSheetDocument");
        return [];
    }
};

const deleteProgressTrackingSheetDocument = async (sheet_id) => {
    try {
        const res = await axios.delete(
            `${developIp}/windcontract/progress_tracking_sheet/document/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    ...getHeaders().headers,
                },
                data: { sheet_id },
            }
        );

        if (res.data.status === 200 || res.data.status === "200") {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        logError(error, "deleteProgressTrackingSheetDocument");
        return false;
    }
};


const getEventNotifications = async (body) => {
    return axios.post(
        `${developIp}/windcontract/event_notifications/page_index/page_size/list/`,
        body,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            }
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                const result = res.data || {};
                return result;
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "getEventNotifications");
            return [];
        });
};

const getEventNotificationsForGis = async (body) => {
    return axios.post(
        `${developIp}/windcontract/group/event_notifications/page_index/page_size/list/`,
        body,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            }
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                const result = res.data || {};
                return result;
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "getEventNotificationsForGis");
            return [];
        });
};

const createAnEventNotification = async (formData) => {
    return axios.post(
        `${developIp}/windcontract/event_notification/new_event/`,
        formData,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            },
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                return res.data.data || {};
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "createAnEventNotification");
            return {};
        });
};

const getAnEventNotification = async (sheet_id) => {
    try {
        const res = await axios.get(
            `${developIp}/windcontract/event_notification/${sheet_id}/event/`,
            getHeaders()
        );

        if (res.data.status === 200 || res.data.status === "200") {
            return res.data || { data: {} };
        } else {
            return [];
        }
    } catch (error) {
        logError(error, "getAnEventNotification");
        return [];
    }
};

const updateAnEventNotification = async (formData) => {
    return axios.put(
        `${developIp}/windcontract/event_notification/details/`,
        formData,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            },
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                return res.data.data || {};
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "updateAnEventNotification");
            return {};
        });
};

const deleteAnEventNotification = async (event_notification_id) => {
    try {
        const res = await axios.delete(
            `${developIp}/windcontract/event_notification/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    ...getHeaders().headers,
                },
                data: { event_notification_id },
            }
        );

        if (res.data.status === 200 || res.data.status === "200") {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        logError(error, "deleteAnEventNotification");
        return false;
    }
};

// ========== WindContract Groups ==========
const getWindcontractGroups = async (body) => {
    return axios.post(
        `${developIp}/windcontract/groups/page_index/page_size/list/`,
        body,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            }
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                return res.data || {};
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "getWindcontractGroups");
            return {};
        });
};

const getAWindcontractGroup = async (windcontract_group_id) => {
    try {
        const res = await axios.get(
            `${developIp}/windcontract/groups/group/${windcontract_group_id}/details/`,
            getHeaders()
        );

        if (res.data.status === 200 || res.data.status === "200") {
            return res.data || { data: {} };
        } else {
            return {};
        }
    } catch (error) {
        logError(error, "getAWindcontractGroup");
        return {};
    }
};

const createAWindcontractGroup = async (formData) => {
    return axios.post(
        `${developIp}/windcontract/groups/new_group/`,
        formData,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            }
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                return res.data.data || {};
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "createAWindcontractGroup");
            return {};
        });
};

const updateAWindcontractGroup = async (formData) => {
    return axios.put(
        `${developIp}/windcontract/groups/details/`,
        formData,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            }
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                return res.data.data || {};
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "updateAWindcontractGroup");
            return {};
        });
};

const deleteAWindcontractGroup = async (windcontract_group_id) => {
    try {
        const res = await axios.delete(
            `${developIp}/windcontract/groups/group/`,
            {
                headers: {
                    "Content-Type": "application/json",
                    ...getHeaders().headers,
                },
                data: { windcontract_group_id },
            }
        );

        if (res.data.status === 200 || res.data.status === "200") {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        logError(error, "deleteAWindcontractGroup");
        return false;
    }
};

const getProgressTrackingSheetDocxFile = async (body) => {
    return axios.post(
        `${developIp}/windcontract/progress_tracking_sheet/document/docx_file/`,
        body,
        {
            headers: {
                "Content-Type": "application/json",
                ...getHeaders().headers,
            }
        }
    )
        .then((res) => {
            if (res.data.status === 200 || res.data.status === "200") {
                return res.data.data || {};
            } else {
                return {};
            }
        })
        .catch((error) => {
            logError(error, "getProgressTrackingSheetDocxFile");
            return {};
        });
};


const Gis = {
    getAllDocks,
    getAllNearLands,
    getAllWindContracts,
    getAllStoreParts,
    getStorePartDockInfo,
    getWindTurbineNum,
    getDailyPlanStats,
    getGisStepReportDataV2,
    getGisStepReportDataV2R2,
    getWindcontractsV2,
    getAdministrativeContractFieldNames,
    getAdministrativeContracts,
};
const actions = {
    clearKey,
    wind_id,
    Gis,
    getWorkingPhase,
    getSingleWindExcel,
    getMultipleWindExcel,
    getAllUnapprovalAdminPrograms,
    getAllUnapprovalWorkProgress,
    getProgressTrackingSheetDocuments,
    getManagerProgressTrackingSheetDocuments,
    getProgressTrackingSheetColumnInfo,
    createProgressTrackingSheetDocument,
    getLastProgressTrackingSheetDocument,
    getAProgressTrackingSheetDocument,
    deleteProgressTrackingSheetDocument,
    getEventNotifications,
    getEventNotificationsForGis,
    createAnEventNotification,
    getAnEventNotification,
    deleteAnEventNotification,
    updateAnEventNotification,
    getWindcontractGroups,
    getAWindcontractGroup,
    createAWindcontractGroup,
    updateAWindcontractGroup,
    deleteAWindcontractGroup,
    getProgressTrackingSheetDocxFile,
};

export default actions;
